import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "collection"
}
const _hoisted_2 = { class: "collection__header-image-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "collection__header-info-wrapper" }
const _hoisted_5 = { class: "collection__header-info-content" }
const _hoisted_6 = { class: "collection__sub-title-wrapper" }
const _hoisted_7 = { class: "collection__sub-title" }
const _hoisted_8 = {
  key: 0,
  class: "collection__main-wrapper"
}
const _hoisted_9 = { class: "collection__gallery-grid" }
const _hoisted_10 = { class: "home__gallery-list" }
const _hoisted_11 = { class: "collection__feedback-wrapper" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderContent = _resolveComponent("RenderContent")!
  const _component_GalleryCard = _resolveComponent("GalleryCard")!

  return (_ctx.collection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "collection__header-image",
            src: _ctx.collection.headerImage.url,
            alt: _ctx.collection.headerImage.description
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.collection.collectionTag), 1)
            ]),
            (_ctx.panels)
              ? (_openBlock(), _createBlock(_component_RenderContent, {
                  key: 0,
                  panels: _ctx.panels
                }, null, 8, ["panels"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.sortedGalleries?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "collection__artworks-heading" }, "Collections", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGalleries, (gallery, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "home__gallery-item-wrapper"
                    }, [
                      _createVNode(_component_GalleryCard, {
                        gallery: gallery,
                        type: "gallery"
                      }, null, 8, ["gallery"])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            class: "collection__feedback-link",
            target: "_blank",
            href: _ctx.GENERAL_FEEDBACK_URL
          }, "Give Feedback", 8, _hoisted_12),
          _createElementVNode("a", {
            class: "collection__support-link",
            target: "_blank",
            href: _ctx.SUPPORT_US_URL
          }, "Donate", 8, _hoisted_13)
        ])
      ]))
    : _createCommentVNode("", true)
}